import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { FolderOpen, Lock } from "lucide-react";
import { SavedSimulationsModal } from "./SavedSimulationsModal";
import { Logo } from "./Logo";

export function Footer() {
  const [savedOpen, setSavedOpen] = useState(false);

  return (
    <footer className="mt-16 border-t border-border bg-secondary py-10">
      <div className="mx-auto max-w-6xl px-6 lg:px-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <Logo size={40} />
            <p className="mt-3 text-sm text-muted-foreground">
              Le simulateur le plus simple pour évaluer votre investissement LMNP.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs leading-relaxed text-muted-foreground">
              <strong className="font-semibold text-foreground">Disclaimer.</strong>{" "}
              RentaLMNP fournit des estimations à titre strictement informatif. Les
              résultats sont basés sur les règles fiscales LMNP 2026 et les données que
              vous avez saisies. Ils ne constituent pas un conseil fiscal, juridique ou
              patrimonial. Avant toute décision d'investissement, consultez un
              expert-comptable, un conseiller en gestion de patrimoine ou un avocat
              fiscaliste.
            </p>
            <p className="mt-3 flex items-start gap-1.5 text-xs leading-relaxed text-muted-foreground">
              <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0 text-foreground" aria-hidden />
              <span>
                <strong className="font-semibold text-foreground">Simulation 100% confidentielle.</strong>{" "}
                Vos simulations restent sur votre appareil. L'email éventuel est utilisé
                uniquement pour vous envoyer votre analyse.{" "}
                <Link to="/confidentialite" className="font-medium text-primary hover:underline">
                  Voir notre politique de confidentialité
                </Link>
                .
              </span>
            </p>
          </div>
        </div>
        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row">
          <span>© {new Date().getFullYear()} RentaLMNP. Conçu en France.</span>
          <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <button
              type="button"
              onClick={() => setSavedOpen(true)}
              className="inline-flex items-center gap-1 hover:text-foreground"
            >
              <FolderOpen className="h-3.5 w-3.5" />
              Mes simulations
            </button>
            <Link to="/comparateur-micro-bic-reel" className="hover:text-foreground">Micro-BIC vs Réel</Link>
            <Link to="/methodologie" className="hover:text-foreground">Méthodologie</Link>
            <Link to="/faq" className="hover:text-foreground">FAQ</Link>
            <Link to="/partenaires" className="hover:text-foreground">Nos partenaires</Link>
            <Link to="/confidentialite" className="hover:text-foreground">Confidentialité</Link>
            <Link to="/mentions-legales" className="hover:text-foreground">Mentions légales</Link>
          </nav>
        </div>
      </div>

      <SavedSimulationsModal open={savedOpen} onOpenChange={setSavedOpen} />
    </footer>
  );
}
